import { buildModelManager } from "../builder.js";
const DefaultAuditLogV2Selection = {
  __typename: true,
  id: true,
  action: true,
  approved: true,
  approvedAt: true,
  approvedById: true,
  conversationId: true,
  createdAt: true,
  details: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "auditLogV2";
const pluralModelApiIdentifier = "auditLogV2s";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAuditLogV2Selection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAuditLogV2",
    operationReturnType: "CreateAuditLogV2",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { auditLogV2: { required: false, type: "CreateAuditLogV2Input" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "action",
    operationName: "bulkCreateAuditLogV2s",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAuditLogV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "action",
    operationName: "updateAuditLogV2",
    operationReturnType: "UpdateAuditLogV2",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      auditLogV2: { required: false, type: "UpdateAuditLogV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpdateAuditLogV2s",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAuditLogV2sInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "action",
    operationName: "deleteAuditLogV2",
    operationReturnType: "DeleteAuditLogV2",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAuditLogV2s",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAuditLogV2",
    operationReturnType: "UpsertAuditLogV2",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      auditLogV2: { required: false, type: "UpsertAuditLogV2Input" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAuditLogV2Result": { hasReturnType: false },
      "... on UpdateAuditLogV2Result": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "action",
    operationName: "bulkUpsertAuditLogV2s",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAuditLogV2sInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAuditLogV2Selection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "auditLogV2GellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AuditLogV2Manager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAuditLogV2Selection,
  operations
);
export {
  AuditLogV2Manager,
  DefaultAuditLogV2Selection
};
//# sourceMappingURL=AuditLogV2.js.map
